module.exports = __webpack_public_path__ + "img/phone-telephone_default.dd1d6eee.svg";